import React, { useEffect } from 'react';
import { Line } from 'react-chartjs-2';


export interface QuickLoansStatisticsProps {

}

export const QuickLoansStatistics = (props: QuickLoansStatisticsProps) => {


    return <div className="QuickLoansContainer">
        <table id="tablePreview" className="table">
            <thead>
                <tr>
                    <th>Datum</th>
                    <th style={{ width: '30%' }}>Kdo dluží?</th>
                    <th style={{ width: '120px' }}>Částka</th>
                    <th style={{ width: '40%' }}>Popis</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>7.6.2020</td>
                    <td>Zbyněk Hrdlička</td>
                    <td>2.100 Kč</td>
                    <td>Vstupenky do Dinoparku</td>
                </tr>
                <tr>
                    <td>13.7.2020</td>
                    <td>Rodiče</td>
                    <td>1.650 Kč</td>
                    <td>Benzín na hory</td>
                </tr>
            </tbody>
        </table>

        <table id="tablePreview" className="table">
            <thead>
                <tr>
                    <th>Datum</th>
                    <th style={{ width: '30%' }}>Komu dlužím?</th>
                    <th style={{ width: '120px' }}>Částka</th>
                    <th style={{ width: '40%' }}>Popis</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>5.8.2020</td>
                    <td>Jan Novák</td>
                    <td>1.500 Kč</td>
                    <td>Útrata v hospodě</td>
                </tr>
            </tbody>
        </table>
    </div >
}